import API from '@/api'

const actions = {
  getRates({ commit }, payload) {
    API.rates.get(payload)
      .then(({ data: { data } }) => {
        commit('setRates', data)
      })
      .catch(({ data: { errors } }) => {
        commit('setErrorsStatus', true)
      })
  },
}

export default actions